import { usePDF } from '@react-pdf/renderer';
import React, { useEffect, useMemo, useState } from 'react';
import ReporteVisitaDocument from './ReporteVisitaDocument';
import { resolveSignatureUrl } from 'api/signatures';

// Toma la key de firma del primer bloque `signatures` con firma cargada.
// (MVP: una firma por reporte; múltiples bloques mostrarían la misma.)
function firstSignatureKey(reporte) {
  const blocks = Array.isArray(reporte?.secciones) ? reporte.secciones : [];
  const sig = blocks.find((b) => b.type === 'signatures' && b.config?.specialistSignatureKey);
  return sig?.config?.specialistSignatureKey || null;
}

// Descarga on-demand del PDF. Resuelve la firma (key S3 → URL presigned) ANTES
// de generar el documento — los hooks async no funcionan dentro de @react-pdf.
function Dowload({ reporte, clienteNombre, config }) {
  const [data, setData] = useState({});
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const key = firstSignatureKey(reporte);
      const url = key ? await resolveSignatureUrl(key) : null;
      if (!cancelled) {
        setData(url ? { specialist_signature: url } : {});
        setReady(true);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [reporte]);

  const document = useMemo(
    () => (
      <ReporteVisitaDocument
        reporte={reporte}
        clienteNombre={clienteNombre}
        data={data}
        config={config || {}}
      />
    ),
    [reporte, clienteNombre, data, config]
  );

  const [instance, updateInstance] = usePDF({ document });
  useEffect(() => {
    if (document) updateInstance(document);
  }, [document, updateInstance]);

  if (!ready || instance.loading) return <span>Generando PDF…</span>;
  if (instance.error) return <span>Algo salió mal: {instance.error}</span>;
  return (
    <a href={instance.url} download={`Reporte-visita-${reporte?.id ?? ''}.pdf`}>
      Descargar reporte de visita
    </a>
  );
}

export default Dowload;
